export default __webpack_public_path__ + "static/URWDIN-Bold-b5ecc659adec83087b771f38617e53e8.woff";